<template>
  <div class="wrapper">
    <el-dialog
        :title="rowId ? '编辑用户' : '新增用户'"
        :visible.sync="showAddOrEdit"
        width="900px"
        :before-close="cancelFun"
        class="user-dialog"
    >
      <div>
        <el-form ref="form" :model="formData" label-width="130px" class="user-form">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="userName" label="用户名" :rules="rules">
                <el-input v-model="formData.userName" placeholder="请输入用户名" clearable class="form-input"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="手机号" prop="mobile" :rules="rules">
                <el-input v-model="formData.mobile" placeholder="请输入手机号" clearable class="form-input"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="性别" prop="gender" :rules="rules">
                <SelectDict :width="'400px'" v-model="formData.gender" dictCode="user:gender" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="roleId" label="角色" :rules="rules">
                <SelectRole :width="'400px'" v-model="formData.roleId"></SelectRole>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="部门" prop="deptId" :rules="rules">
                <SelectDept :width="'400px'" v-model="formData.deptId"></SelectDept>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelFun" size="small">取 消</el-button>
        <el-button type="primary" @click="submitFun" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectRole from '@/views/components/select-role.vue';
import SelectDept from '@/views/components/select-dept.vue';
import SelectDict from '@/views/components/select-dict.vue';
import { addAdmin, editAdmin, getAdminDetail, getRoleList } from './api';

export default {
  name: 'Detail',
  components: { SelectRole, SelectDept, SelectDict },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        userName: '',
        mobile: '',
        roleId: null,
        gender: null,
        deptId: null,
        jobId: null
      },
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      roleList: [],
      roleProps: {
        children: 'children',
        label: 'name',
        value: 'id',
        emitPath: false,
        multiple: true
      },
      genderList: []
    }
  },

  mounted() {
    this.getRoleList()
    this.getDictEnumList()
    if (this.rowId) this.getAdminDetail()
  },

  methods: {
    submitFun() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 编辑
          await (this.rowId ? editAdmin : addAdmin)(this.formData).then(() => {
            this.$message.success(this.rowId ? '编辑成功' : '新增成功')
            this.$emit("closeDialog",true);
          })
        } else {
          return false;
        }
      })
    },
    async getAdminDetail() {
      this.formData = await getAdminDetail({ id: this.rowId })
      this.formData.gender = this.formData.gender.toString()
    },
    cancel() {
      this.$router.back(-1)
    },
    async getRoleList() {
      const res = await getRoleList({ pageSize: 50, page: 1 })
      this.roleList = res.list || []
    },
    async getDictEnumList() {
      this.genderList = await getDictEnumListAPI('gender')
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
.user-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.user-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  // SelectDict, SelectRole, SelectDept 组件样式
  ::v-deep {
    .select-dict,
    .select-role,
    .select-dept {
      width: 100%;
      max-width: 400px;

      .el-input__inner {
        border-radius: 4px;
        transition: all 0.3s ease;

        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }

        &:hover {
          border-color: #c0c4cc;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .user-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto !important;
    }
  }

  .form-input {
    max-width: 100% !important;
  }

  .user-form {
    ::v-deep {
      .select-dict,
      .select-role,
      .select-dept {
        max-width: 100% !important;
      }
    }
  }
}
</style>
